<template>
  <div class="task-evaluation">
    <div class="task-evaluation__task" v-html="evaluation.task"></div>
    <label class="task-evaluation__label">Ваша відповідь</label>
    <div class="task-evaluation__editor">
      <vue-editor v-model="answer" :editorToolbar="customToolbar"></vue-editor>
    </div>
    <button
      class="task-evaluation__submit"
      type="button"
      :disabled="!hasAnswer"
      @click="sendAnswer"
    >
      Надіслати на перевірку
      <v-icon size="19">mdi-send</v-icon>
    </button>
  </div>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';
import { VueEditor } from 'vue2-editor';
export default {
  name: 'TaskEvaluation',
  components: { VueEditor },
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: this.evaluation.answer || '',
      //https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link'], //'image', 'video'
        ['clean'], // remove formatting button
      ],
    };
  },
  watch: {
    evaluation(evaluation) {
      this.answer = evaluation.answer;
    },
  },

  computed: {
    hasAnswer() {
      const container = document.createElement('div');
      container.innerHTML = this.answer || '';
      return (container.textContent || '').replace(/[\u00a0\u200b-\u200d\ufeff]/g, ' ').trim().length > 0;
    },
  },

  methods: {
    sendAnswer() {
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.answer,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.task-evaluation__task { color: #172033; font-size: 18px; font-weight: 700; line-height: 1.55; margin-bottom: 22px; }
.task-evaluation__task::v-deep p { margin: 0 0 8px; }
.task-evaluation__task::v-deep * { color: var(--theme-banner-text) !important; }
.task-evaluation__label { color: #344054; display: block; font-size: 13px; font-weight: 800; margin-bottom: 7px; }
.task-evaluation__editor { border: 1px solid #d9e2de; border-radius: 12px; max-width: 800px; overflow: hidden; }
.task-evaluation__editor:focus-within { border-color: var(--theme-accent-decorative); box-shadow: 0 0 0 3px var(--theme-surface-decorative); }
.task-evaluation__editor::v-deep .ql-toolbar { background: #f8faf9; border: 0; border-bottom: 1px solid #e4e9e6; }
.task-evaluation__editor::v-deep .ql-container { border: 0; font-size: 14px; min-height: 120px; }
.task-evaluation__submit { align-items: center; background: var(--theme-header-background); border: 0; border-radius: 10px; color: var(--theme-header-text); cursor: pointer; display: inline-flex; font-size: 14px; font-weight: 800; gap: 8px; margin-top: 16px; min-height: 44px; padding: 10px 18px; }
.task-evaluation__submit:hover:not(:disabled) { filter: brightness(.9); }.task-evaluation__submit:disabled { cursor: not-allowed; opacity: .45; }
.task-evaluation__submit::v-deep .v-icon { color: currentColor !important; }
@media (max-width: 600px) { .task-evaluation__task { font-size: 16px; }.task-evaluation__submit { justify-content: center; width: 100%; } }
</style>
